import styles from "./background.module.scss"
import { useNavigate } from "react-router-dom"

import RBBackground from "../../assets/images/backgrounds/background-redbull.png"

import Close from "../../assets/images/icons/close.svg"
import trim from "../../assets/images/textures/trim.svg"
import chequered from "../../assets/images/textures/cheq-cropped.svg"

// Returns the background component
export default function Background({ children }) {
	const navigate = useNavigate()

	return (
		<div className={styles.wrapper}>
			<div
				className={styles.close}
				style={{ backgroundImage: `url("${Close}")` }}
				onClick={() => navigate("/")}
			/>

			<div
				className={styles.background}
				style={{ backgroundImage: `url('${RBBackground}')` }}
			/>

			<div
				className={styles.trim}
				style={{ backgroundImage: `url('${trim}')` }}
			/>

			<div
				className={styles.chequered}
				style={{ backgroundImage: `url('${chequered}')` }}
			/>

			{children}
		</div>
	)
}
